<script setup>
// O campo de mensagem do chat ao vivo: o editor do woot (contenteditable com formatação) vestido como campo do kit
// (borda, foco, raio, erro). Só desta área: o `Editor` de components-next é de outras telas e fica como está.
// Mesmo limite e mesma contagem do `Editor` (200 caracteres).
import { computed, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import WootEditor from 'dashboard/components/widgets/WootWriter/Editor.vue';

const props = defineProps({
  modelValue: { type: String, default: '' },
  placeholder: { type: String, default: '' },
  maxLength: { type: Number, default: 200 },
  invalid: { type: Boolean, default: false },
  ariaLabel: { type: String, default: '' },
});

const emit = defineEmits(['update:modelValue', 'blur']);

const { t } = useI18n();

const characterCount = computed(() => props.modelValue.length);

watch(
  () => props.modelValue,
  value => {
    if (characterCount.value >= props.maxLength) {
      emit('update:modelValue', value.slice(0, props.maxLength));
    }
  }
);
</script>

<template>
  <div
    class="flex min-w-0 flex-col gap-2 rounded-polaris-md border border-solid bg-transparent px-3 py-3 shadow transition-[color,box-shadow] focus-within:ring-[3px] dark:bg-polaris-input/30 [&_.ProseMirror-menubar]:!relative [&_.ProseMirror-menubar]:!top-auto [&_.ProseMirror-menubar]:!w-fit [&_.ProseMirror-woot-style_.empty-node]:!m-0 [&_.ProseMirror-woot-style_p:first-child]:!mt-0"
    :class="
      invalid
        ? 'border-polaris-destructive ring-polaris-destructive/20 dark:ring-polaris-destructive/40'
        : 'border-polaris-input focus-within:border-polaris-ring focus-within:ring-polaris-ring/50'
    "
    :aria-label="ariaLabel || undefined"
    data-campaign-message-editor
    @focusout="emit('blur')"
  >
    <WootEditor
      :model-value="modelValue"
      :placeholder="placeholder"
      :focus-on-mount="false"
      @input="value => emit('update:modelValue', value)"
    />
    <div class="flex h-4 items-center justify-end">
      <span
        class="type-polaris-caption tabular-nums text-polaris-muted-foreground"
      >
        {{
          t('CAMPAIGN.DRAWER.CHARACTERS', {
            count: characterCount,
            max: maxLength,
          })
        }}
      </span>
    </div>
  </div>
</template>
